<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>年夜饭预定管理</el-breadcrumb-item>
        <el-breadcrumb-item>客房管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form ref="listForm" :model="listParams" label-width="120px" inline>
        <el-form-item label="选择餐厅：" prop="canteenId">
          <el-select v-model="listParams.canteenId" placeholder="请选择餐厅" class="w300">
            <el-option v-for="(item, index) in restaurantList" :key="index" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="客房名称：" prop="roomName">
          <el-input class="w300" v-model="listParams.roomName" placeholder="请填写客房名称" />
        </el-form-item>

        <el-form-item label="">
          <el-button @click="loadTableData(true)" type="primary">查询</el-button>
          <el-button @click="$refs.listForm.resetFields()">重置</el-button>
        </el-form-item>
      </el-form>

      <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
        <div slot="action"></div>

        <hx-table-result-col>
          <div class="wrap-table-info-display">
            <el-button @click="handleDialog('')" type="primary">新增</el-button>
            <span class="table-info-display">
              <span>总条数：</span>
              <span class="alert-text ft16">{{ pager.total }}</span>
            </span>
          </div>
        </hx-table-result-col>

        <el-table slot="content" :data="tableData" border>
          <icTableColumnIndex :pageIndex="pager.pageIndex" :pageSize="pager.pageSize" />

          <el-table-column label="餐厅名称" prop="canteenName" align="center" />

          <el-table-column label="图片" prop="picture" align="center">
            <template slot-scope="scope">
              <el-image style="width: 80px" :src="scope.row.picture" />
            </template>
          </el-table-column>

          <el-table-column label="客房名称" prop="roomName" align="center" />

          <el-table-column label="联系电话" prop="contactMobile" align="center" />

          <el-table-column label="操作" prop="" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="handleUpdate(scope.row.guestRoomInfoIdStr)">编辑</el-button>
              <confirm-button type="text" class="mgl10" title="确认要删除该客房吗？" @confirmed="handleDelete(scope.row.guestRoomInfoIdStr)">
                <span>删除</span>
              </confirm-button>
            </template>
          </el-table-column>
        </el-table>
      </hx-table-result>
    </div>

    <el-dialog title="客房管理" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" top="10px" width="800px">
      <el-form ref="dialogForm" :model="dialogForm" :rules="dialogRules" label-width="120px" size="small">
        <el-form-item label="所属餐厅：" prop="canteenId">
          <el-select v-model="dialogForm.canteenId" placeholder="请选择餐厅" style="width: 100%">
            <el-option v-for="(item, index) in restaurantList" :key="index" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>

        <el-form-item label="客房名称：" prop="name">
          <el-input v-model="dialogForm.name" placeholder="请填写客房名称" :maxlength="20" show-word-limit />
        </el-form-item>

        <el-form-item label="联系电话：" prop="contactMobile">
          <el-input v-model="dialogForm.contactMobile" placeholder="请填写联系电话" :maxlength="11" show-word-limit />
        </el-form-item>

        <el-form-item label="客房主图：" prop="picture">
          <el-input v-model="dialogForm.picture" type="hidden" />
          <oss-uploader @setImage="handleUploadImage" :previewList="previewList"></oss-uploader>
        </el-form-item>

        <el-form-item label="收费标准：" prop="price">
          <el-input-number v-model="dialogForm.price" placeholder="请填写客房价格" :maxlength="6" />
          <span class="tip">元/间</span>
        </el-form-item>

        <el-form-item label="每日库存：" prop="stocks">
          <div class="listWrapper">
            <div class="item" v-for="(item, index) in dialogForm.stocks" :key="index">
              <span class="label">{{ item.guestDate }}：</span>
              <el-input-number v-model="item.stock" placeholder="请填写" :disabled="!!dialogForm.guestRoomId" :maxlength="6" />
            </div>
          </div>
          <template v-if="!dialogForm.guestRoomId">
            <span class="tip">批量填写库存：</span>
            <el-input-number v-model="dialogForm.stock" :maxlength="6" />
            <el-button type="primary" class="mgl10" @click="handleUpdateStock">更新</el-button>
          </template>
        </el-form-item>

        <el-form-item label-width="0px" style="text-align: center">
          <el-button size="default" @click="dialogVisible = false">取消</el-button>
          <el-button size="default" @click="handleSubmit()" type="primary" :disabled="subLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";

const defaultStocks = [
  { guestDate: "2023-01-16", stock: 0 },
  { guestDate: "2023-01-17", stock: 0 },
  { guestDate: "2023-01-18", stock: 0 },
  { guestDate: "2023-01-19", stock: 0 },
  { guestDate: "2023-01-20", stock: 0 },
  { guestDate: "2023-01-21", stock: 0 },
  { guestDate: "2023-01-22", stock: 0 },
  { guestDate: "2023-01-23", stock: 0 },
  { guestDate: "2023-01-24", stock: 0 },
  { guestDate: "2023-01-25", stock: 0 },
  { guestDate: "2023-01-26", stock: 0 },
  { guestDate: "2023-01-27", stock: 0 },
];
const defaultParams = {
  name: "",
  picture: "",
  contactMobile: "",
  canteenId: "",
  price: "",
  stocks: defaultStocks,
};

export default {
  data() {
    return {
      listParams: {
        canteenId: "",
        roomName: "",
      },
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      tableLoading: false,
      dialogVisible: false,
      dialogForm: { ...defaultParams },
      dialogRules: {
        canteenId: [{ required: true, message: "请选择餐厅", trigger: "change" }],
        name: [{ required: true, message: "请填写客房名称", trigger: "blur" }],
        picture: [{ required: true, message: "请填写客房主图", trigger: "change" }],
        contactMobile: [{ required: true, message: "请填写联系电话", trigger: "blur" }],
        price: [{ required: true, message: "请填写客房价格", trigger: "blur" }],
      },
      subLoading: false,
      restaurantList: [],
      previewList: [],
    };
  },

  mounted() {
    this.loadTableData();
    this.loadRestaurantList();
  },

  methods: {
    /**
     * @description: 加载列表
     * @param {*} isReset
     * @return {*}
     */
    loadTableData(isReset) {
      if (isReset) {
        this.pager.pageIndex = 1;
      }
      this.tableLoading = true;
      const bodyParams = Object.assign(this.listParams, this.pager);
      this.$http({
        url: global.apiUrl + "/guest/room/list",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            this.tableData = res.body.data.data;
            this.pager.total = res.body.data.total;
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;
          console.error(err);
        });
    },
    /**
     * @description:
     * @param {*}
     * @return {*}
     */
    async loadRestaurantList() {
      const url = `${global.apiUrl}/canteen`;
      const response = await Vue.ajaxGet(this, url, { pageIndex: 1, pageSize: 100 });
      const data = response.data || [];
      this.restaurantList = data;
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },

    /**
     * @description: 编辑客房
     * @param {*} id
     * @return {*}
     */
    async handleUpdate(id) {
      try {
        const url = `${global.apiUrl}/guest/room/detail`;
        const response = await Vue.ajaxGet(this, url, { guestRoomId: id }, "tableLoading");
        const data = response || {};
        if (data.picture) {
          this.previewList = [data.picture];
        }
        let stocks = [...defaultStocks];
        if (data.stocks) {
          stocks = defaultStocks.map(item => {
            const temp = data.stocks.find(t => t.guestDate == item.guestDate);
            return temp ? { ...temp } : { ...item };
          });
        }
        this.dialogForm = { ...data, guestRoomId: id, canteenId: data.canteenId + "", stocks };
        this.handleDialog(id);
      } catch (error) {
        console.error(error);
      }
    },
    /**
     * @description: 删除客房
     * @param {*} id
     * @return {*}
     */
    handleDelete(id) {
      this.$http({
        url: global.apiUrl + "/guest/room/delete",
        method: "DELETE",
        params: { guestRoomId: id },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData(true);
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * @description: 打开弹框
     * @param {*} id
     * @return {*}
     */
    handleDialog(id) {
      if (id) {
      } else {
        this.handleResetForm();
      }
      this.dialogVisible = true;
    },
    /**
     * @description: 获取图片
     * @param {*} file
     * @return {*}
     */
    handleUploadImage(file) {
      this.dialogForm.picture = file;
    },
    /**
     * 批量更新库存
     */
    handleUpdateStock() {
      if (this.dialogForm.stock) {
        this.dialogForm.stocks.forEach((item, index) => {
          this.dialogForm.stocks[index].stock = this.dialogForm.stock;
        });
      } else {
        this.$message.warning("请输入批量填写库存！");
      }
    },
    /**
     * @description: 保存表单
     * @param {*} name
     * @return {*}
     */
    handleSubmit() {
      this.$refs.dialogForm.validate(async valid => {
        if (valid) {
          const bodyParams = Object.assign(this.dialogForm);
          try {
            let response = null;
            if (bodyParams.guestRoomId) {
              const url = `${global.apiUrl}/guest/room/update`;
              response = await Vue.ajaxPut(this, url, bodyParams);
            } else {
              const url = `${global.apiUrl}/guest/room/add`;
              response = await Vue.ajaxPost(this, url, bodyParams);
            }
            this.$message.success(response.info);
            this.dialogVisible = false;
            this.loadTableData(true);
            this.handleResetForm();
          } catch (error) {
            console.error(error);
          }
        }
      });
    },

    /**
     * 重置表单
     */
    handleResetForm() {
      this.dialogForm = { ...defaultParams, stocks: defaultStocks };
      this.previewList = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.tip {
  font-size: 14px;
  color: #666;
}
.listWrapper {
  display: flex;
  flex-wrap: wrap;
  .item {
    margin-bottom: 5px;
    margin-right: 20px;
    .label {
      width: 100px;
      text-align: right;
      display: inline-block;
    }
  }
}
</style>
